import React from 'react';
import { Heading } from '../../components';

import classNames from 'classnames';
import css from '../../containers/ListingPage/ListingPage.module.css';

import {
  FaVideo,
  FaUserTie,
  FaShieldAlt,
  FaBed,
  FaPills,
  FaGripLines,
  FaLock,
  FaFireExtinguisher,
  FaUmbrellaBeach,
} from 'react-icons/fa';

import { GiBusDoors, GiFirstAidKit, GiPawHeart, GiSpikedFence } from 'react-icons/gi';
import { TbDeviceCctvFilled, TbDog } from 'react-icons/tb';
import { LuCctv } from 'react-icons/lu';
import { LiaDoorOpenSolid } from 'react-icons/lia';
import { ImExit } from 'react-icons/im';
import { BsBoundingBoxCircles } from 'react-icons/bs';

const outdoorFeaturesDisplayData = {
  balcony: { name: 'Balcony', icon: <LiaDoorOpenSolid /> },
  lawn: { name: 'Lawn', icon: <TbDog /> },
  open_area: { name: 'Open Area', icon: <FaUmbrellaBeach /> },
};

const SectionOutdoorFeatures = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.topFacilitiesList}>
        {selectedOptions.map(option => {
          const feature = outdoorFeaturesDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{feature?.icon}</span>
              <span>{feature?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionOutdoorFeatures;
